import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// [视频陪聊主播申请状态] http://wiki.xunlei.cn/pages/viewpage.action?pageId=105293365
export const get_anchor_status = createAsyncThunk(
  'get_anchor_status',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'status'
          | 'is_apply'
          | 'review_status'
          | 'video_url'
          | 'video_poster'
          | 'video_dur'
        >
      >
    >('/live/facetime/get_anchor_status', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// [申请成为陪聊主播] http://wiki.xunlei.cn/pages/viewpage.action?pageId=105291278
export const apply_facetime_anchor = createAsyncThunk(
  'apply_facetime_anchor',
  async (
    arg: {
      video_url?: string
      video_poster?: string
      video_dur?: number
      not_apply?: number
      question?: number
    },
    store: any
  ) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/facetime/apply_facetime_anchor',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [视频陪聊中心](http://wiki.xunlei.cn/pages/viewpage.action?pageId=105291283)
export const facetime_anchor_center = createAsyncThunk(
  '/live/facetime/facetime_anchor_center',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/facetime/facetime_anchor_center', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// [视频主播工作状态设置](http://wiki.xunlei.cn/pages/viewpage.action?pageId=105291287)
export const anchor_work_status_set = createAsyncThunk(
  '/live/facetime/anchor_work_status_set',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/facetime/anchor_work_status_set', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

// [视频陪聊教育题目](http://wiki.xunlei.cn/pages/viewpage.action?pageId=108626616)
export const facetime_question_list = createAsyncThunk(
  '/live/facetime/question_list',
  async (p, store: any) => {
    const resp = await http.post('/live/facetime/question_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
// [提交题目答案] http://wiki.xunlei.cn/pages/viewpage.action?pageId=108626623
export const facetime_submit_answer = createAsyncThunk(
  '/live/facetime/submit_answer',
  async (arg: {answer: number[]; answer_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{pass: boolean; answer_msg: string}>>(
      '/live/facetime/submit_answer',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)
export interface INotify {
  id: number
  title: string
  content: string
  ct: string
  red_dot: RedDotStatus
}

export enum RedDotStatus {
  unread = 1,
  read = 2,
}

// 陪聊主播通知中心读取某条通知 http://wiki.xunlei.cn/pages/viewpage.action?pageId=105291628
export const anchor_read_messagen = createAsyncThunk(
  '/live/facetime/anchor_read_message',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/facetime/anchor_read_message', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
export enum review_status_enum {
  是主播 = 1,
  申请中 = 2,
  申请失败 = 3,
}
// 题目类型
export enum qTypeEnum {
  单选 = 1,
  多选 = 2,
}
interface LevelType {
  level_image: string // 勋章大图
  level_icon: string // 等级小图
  maintain_coins: number
  up_coins: number
  coins_ratio: number // 金币增幅
  match_ratio: number // 匹配增幅
  level: string // 等级名称
  up_days?: number // 升到下个等级需要的天数
}
interface LevelContentInfo {
  level_image: string
  maintain: string
  upgrade: string
  award: string[]
}
export enum level_status_enum {
  普通 = 0,
  最小 = 1,
  最大 = 2,
}
export interface InitialStateType {
  // 是否申请通过
  is_apply?: boolean
  // 0 目前是主播 1 被移除主播身份了
  status?: 0 | 1
  // 1 已经是主播了 2 申请中，3申请失败
  review_status?: review_status_enum
  video_url?: string
  video_poster?: string
  video_dur?: number
  QA?: {
    poster: string
    video: string
    list: {
      idx: number
      question: string
      type: qTypeEnum
      options: {
        idx: number
        content: string
      }[]
    }[]
  }
  center?: {
    avatar: string
    mid: number
    name: string
    evaluate: string
    work_status: 0 | 1
    today_coins: number
    task_list: Array<{
      name: string
      coins: number
      number: number
    }>
    coins_history_list: Array<{
      coins: number
      date: string
    }>
    unread_notification: any
    unread_cnt: number
    // 20230301 优化内容
    current_level: LevelType
    next_level: LevelType
    total_coins: number // 近七天金币数
    level_status: level_status_enum // 0 不是最大也不是最小，1最小 2最大
    level_content_info_list: LevelContentInfo[] // 级别策略
  }
}

const initialState: InitialStateType = {}

export const VChatCenterSlice = createSlice({
  name: 'VChatCenter',
  initialState,
  reducers: {
    applyFace: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        is_apply: true,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_anchor_status.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(facetime_anchor_center.fulfilled, (state, action) => {
      Object.assign(state, {
        center: action.payload,
      })
    })
    builder.addCase(anchor_work_status_set.fulfilled, (state, action) => {
      Object.assign(state, {
        work_status: state.center.work_status ? 0 : 1,
      })
    })
    builder.addCase(facetime_question_list.fulfilled, (state, action) => {
      Object.assign(state, {
        QA: action.payload,
      })
    })
  },
})
export default VChatCenterSlice.reducer
export const VChatCenterActions = VChatCenterSlice.actions
